import { Divider, List } from '@mui/material';
import { Fragment, memo, ReactElement, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { FilterDTO, FilterOptionsDTO } from '../../api';
import { FilterSpec } from './common';
import { FilterListItem } from './FilterListItem';
import { FilterImplemetations } from './Primitives';

export interface CombinedFilterListProps {
  filterOptions?: FilterOptionsDTO;
  filter: FilterDTO;
  filterSpec: FilterSpec[];
  onFilterChange: (filter: FilterDTO) => void;
  onCommit: () => void;
}

export const CombinedFilterList = memo(function ({
  filterOptions,
  filter,
  filterSpec,
  onFilterChange,
  onCommit,
}: CombinedFilterListProps): ReactElement {
  const { t } = useTranslation();

  const handleValueChange = useCallback(
    function <T extends FilterDTO[keyof FilterDTO]>(key: keyof FilterDTO, value: T): void {
      if (value === undefined) {
        // remove filter
        onFilterChange(Object.fromEntries(Object.entries(filter).filter(([k]) => k !== key)));
      } else if (value !== filter[key] || undefined) {
        onFilterChange({ ...filter, [key]: value });
      }
    },
    [filter, onFilterChange]
  );

  return (
    <List>
      {filterSpec.map(({ type, filterProps = {}, filterKey, displayName }, idx) => {
        const Filter = FilterImplemetations[type];
        return (
          <Fragment key={idx}>
            {idx !== 0 && <Divider sx={{ width: '90%', margin: '0 auto' }} />}
            <FilterListItem displayName={t(displayName ?? '')}>
              <Filter
                {...filterProps}
                value={filter[filterKey]}
                onValueChange={(v) => handleValueChange(filterKey, v)}
                filterOptions={filterOptions ? (filterOptions as any)[filterKey] : undefined}
                filterKey={filterKey}
                onCommit={onCommit}
              />
            </FilterListItem>
          </Fragment>
        );
      })}
    </List>
  );
});
